import Axios from "axios"
import * as countryHelper from './countryHelper';

export default{
    namespaced:true,

    state:{
        location:{
            zipCode:"",
            country:{
                label:"",
                value:""
            }
        },
        tax_rate:0
    },
    mutations:{
        UPDATE_ZIP_CODE(state,payload){
            if(payload.zip){
                state.location.zipCode = payload.zip         
            } 
            state.location.country.value = payload.country ?  payload.country :"US"
            // state.location.country.label = 
            //         countries.find(country=> country.value == state.location.country.value).label
            state.location.country.label = countryHelper.getCountryLabel(state.location.country.value)
            
        },
        RESET_LOCATION(state){
            state.location.zipCode=""
            state.location.country.label=""
            state.location.country.value="",
            state.tax_rate = ""
        },
        RESET_ZIP(state){
            state.location.zipCode=""
        },
        UPDATE_TAX_RATE(state,rate){
            state.tax_rate = parseFloat(rate)
        }
    },
    getters:{
        getZipCode(state){
            return state.location.zipCode
            return state.location.country.label == "United States" ? 
                state.location.zipCode :state.location.country.label != "" ? state.location.country.label :""
        },
        getLocation(state){
            return state.location ? state.location :""
        },
        getEstimatedTax(state){
            return state.tax_rate
        } 
    },
    actions:{
       async requetsZipCode({state,commit,dispatch,getters,rootState}){
            if(state.location.country.value == '' || state.location.zipCode == ''){ 
                if(rootState.customer.isAuth){
                    let addresses = _.get(rootState.customer,'customer.addresses')
                    if(addresses && addresses.length > 0){
                        let index = addresses.findIndex(c=> c.default == true)
                        index == -1 ? index = 0:''
                        if(index != -1){
                            let e ={
                                country:{value:rootState.customer.customer.addresses[index].country},
                                zipCode:rootState.customer.customer.addresses[index].postal_code || ""
                            } 
                            dispatch("updateZipCode",e)
                        }else{
                           await Axios("/api/zip_code").then(resp=>{
                                commit("UPDATE_ZIP_CODE",resp.data)
                                if(resp.data.tax_rate){commit("UPDATE_TAX_RATE",resp.data.tax_rate)}               
                            }).catch(err=>{})
                        }
                    }
                }else{
                  await  Axios("/api/zip_code").then(resp=>{
                        commit("UPDATE_ZIP_CODE",resp.data)
                        if(resp.data.tax_rate){commit("UPDATE_TAX_RATE",resp.data.tax_rate)} 
                    }).catch(err=>{})
                }
            }
        },
        updateZipCode({state,commit,getters,rootState},location){
            if(location.zipCode == ""){
                commit("RESET_ZIP")
            }
            let payload = {}            
            if(location.zipCode){
                payload.zipCode = location.zipCode
            }
            if(_.get(location.country,'value')){
                payload.country = location.country.value
            }
            else{
                payload.country =  countryHelper.getCountryValue(location.country.label)
            } 
                Axios.post("/api/zip_code",payload).then(resp=>{
                    commit("UPDATE_ZIP_CODE",resp.data)
                    if(resp.data.hasOwnProperty('tax_rate')){
                        commit("UPDATE_TAX_RATE",resp.data.tax_rate)
                    } 
                }).catch(err=>{})
                
            
        }
    },
}
    


// WEBPACK FOOTER //
// ./resources/js/store/zipLookUp.js